// Laden für die Berichte (Agent 7A): ein Aufruf je Filter, veraltete Antworten werden verworfen; Katalog der Kennzahlen einmal.
import { useCallback, useEffect, useRef, useState } from "react";
import { berichteApi, type Kennzahl } from "../api/berichte";

export interface Geladen<T> {
  daten: T | null;
  laedt: boolean;
  fehler: unknown;
  neuLaden: () => void;
}

export function useGeladen<T>(lade: () => Promise<T>, schluessel: string, aktiv = true): Geladen<T> {
  const [z, setZ] = useState<{ daten: T | null; laedt: boolean; fehler: unknown }>({ daten: null, laedt: aktiv, fehler: null });
  const zaehler = useRef(0);
  const ladeRef = useRef(lade);
  ladeRef.current = lade;
  const neuLaden = useCallback(() => {
    const n = ++zaehler.current;
    setZ((a) => ({ ...a, laedt: true, fehler: null }));
    ladeRef
      .current()
      .then((d) => {
        if (n === zaehler.current) setZ({ daten: d, laedt: false, fehler: null });
      })
      .catch((e) => {
        if (n === zaehler.current) setZ((a) => ({ ...a, laedt: false, fehler: e }));
      });
  }, []);
  useEffect(() => {
    if (aktiv) neuLaden();
    else zaehler.current++;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schluessel, aktiv]);
  return { ...z, neuLaden };
}

let katalogVersprechen: Promise<Kennzahl[]> | null = null;

/** Katalog der Kennzahlen (einmal je Sitzung; ein Fehler wird nicht festgehalten). */
export function useKatalog(): { katalog: Kennzahl[] | null; fehler: unknown } {
  const [katalog, setKatalog] = useState<Kennzahl[] | null>(null);
  const [fehler, setFehler] = useState<unknown>(null);
  useEffect(() => {
    let weg = false;
    katalogVersprechen ??= berichteApi.kennzahlen().then((r) => r.data);
    katalogVersprechen.then(
      (k) => {
        if (!weg) setKatalog(k);
      },
      (e) => {
        katalogVersprechen = null;
        if (!weg) setFehler(e);
      },
    );
    return () => {
      weg = true;
    };
  }, []);
  return { katalog, fehler };
}

export function katalogNachId(katalog: Kennzahl[] | null): Map<string, Kennzahl> {
  return new Map((katalog ?? []).map((k) => [k.id, k]));
}
